import { deepCopy } from "../../../constants";

export const resetSocialWallPersistScreenSettings = () => {
  return (dispatch) => {
    dispatch({
      type: "RESET_SOCIAL_WALL_PERSIST_SCREEN_SETTINGS",
      payload: null,
    });
  };
};
export const setLaunchedScreenValueInPersist = (
  screenValue,
  launchedScreen,
  value = null
) => {
  let updatedLaunchedScreen = deepCopy(launchedScreen);
  updatedLaunchedScreen = {
    ...updatedLaunchedScreen,
    [screenValue]: typeof value === "boolean" ? value : true,
  };
  return (dispatch) => {
    dispatch({
      type: "UPDATE_LAUNCH_SCREEN_IN_PERSIST",
      payload: updatedLaunchedScreen,
    });
  };
};
